var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 2c2.946 0 5.612 2 8 6-2.318 3.882-4.898 5.88-7.74 5.995L8 14c-2.946 0-5.612-2-8-6 2.318-3.882 4.898-5.88 7.74-5.995L8 2zm0 2C5.851 4 4.004 5.483 2.286 8c1.617 2.37 3.35 3.823 5.34 3.985l.249.013L8 12c2.149 0 3.996-1.483 5.714-4-1.656-2.427-3.433-3.893-5.485-3.994L8 4zm0 2c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordShow);
export default __webpack_public_path__ + "static/media/password-show.022e6157f27d6ad2b2453c4024b33222.svg";
export { ForwardRef as ReactComponent };